<template>
  <div
    v-if="!progress">
    <v-card-text>
      <v-container>
        <v-row
          align="start"
          pb-3>
          <v-col cols="12">
            <span>生徒名</span>
            <v-list-item-content class="title">
              <span class="text--primary">{{ this.student.fullName() }}さん</span>
            </v-list-item-content>
          </v-col>
            <v-col cols="12">
              <span>指導曜日/時間帯</span>
              <v-list-item-content class="title">
                <span class="text--primary">{{ offer.lesson.schedule.toString() }}</span>
              </v-list-item-content>
            </v-col>
          <v-col cols="12">
            <span>報酬金額</span>
            <v-list-item-content class="title">
            <span class="text--primary">{{ offer.lesson.wage }}円</span>
            </v-list-item-content>
          </v-col>
          <v-col cols="12">
            <span>応募時コメント</span>
            <v-list-item-content class="title">
              <span class="line--feed" >{{ offer.lesson.note }}</span>
            </v-list-item-content>
          </v-col>
        </v-row>
        <v-row
          v-if="offer.isAgreed()"
          justify="end">
          <v-col cols="12">
            <v-list-item class="title">
              <span>この応募は承認済みです。</span>
            </v-list-item>
          </v-col>
            <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            outlined
            @click="confirm">
            確認
          </v-btn>
        </v-row>
        <v-row
          v-else-if="offer.isInOffer()"
          justify="center">
          <v-col cols="12">
            <v-list-item class="title">
              この応募は未承認(承認待ち)です。
            </v-list-item>
          </v-col>
          <v-btn
            depressed
            rounded
            outlined
            @click="confirm">
            応募を取りやめる
          </v-btn>
        </v-row>
        <v-row
          v-else
          justify="end">
          <v-col cols="12">
            <v-list-item class="title">
              この応募は見送られました。
            </v-list-item>
          </v-col>
            <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            outlined
            @click="confirm">
            確認
          </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { StudentRepository } from '@/repository/StudentRepository.js'

export default {
  name: 'OffersByTeacherList',
  data() {
    return {
      student: null,
      progress: true
    }
  },
  props: {
    offer: Object,
  },
  methods: {
    confirm(offer) {
      this.$emit("confirm", offer)
    },
  },
  created: async function(){
    const studentRepo = new StudentRepository(firestore)
    this.student = await studentRepo.get(this.offer.lesson.studentId)
    this.progress = false
  }
}
</script>
